import currentAnswerResource from 'src/actions/answers/currentAnswerResource';
import useDocumentResource from 'src/presentation/hooks/useDocumentResource';

export default function useCurrentAnswer(answerId) {
  const { loadingState, value: currentAnswer } = useDocumentResource(currentAnswerResource, {
    fetch: answerId != null,
    params: { id: answerId },
  });

  return { loadingState, value: answerId ? currentAnswer : null };
}
